import { privateApi } from 'services/Api/ApiService';
import { TalentEntry } from './types';

const fetchTalentEntries = (talentId: string): Promise<TalentEntry[]> =>
    privateApi.get<TalentEntry[]>(`talents/${talentId}/entries`);

export const TalentEntriesGateway = {
    fetchTalentEntries,
};
